<template>
	<div class="owl-carousel">
		<div class="item" v-for="item in items">
			<!-- <pre>{{items}}</pre> -->
			<a v-if="item.button" data-fancybox :data-src='`#${item.button.popupFormID}`' href="javascript:;" :data-key="item.button.key">
				<img class="img" :src="item.img" alt="">
			</a>
			<a v-else :href="item.href">
				<img class="img" :src="item.img" alt="">
			</a>
		</div>
	</div>
</template>

<script>
module.exports = {

	props: ['items'],

	data () {
		return {
    }
	},

  methods: {
    sendId(formId) {
			console.log(formId);
			$(`#${formId}`).fancybox();
			// $('#id-form').fancybox();
    }
  },

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 1 ? true : false,
				nav: true,
				dots: true
			}
		});
	}
}
</script>

<style lang="scss">
@import "scss/wanted";
.global-slider-container {
	.slider-mainSlider2 {
    // height: 400px;
		overflow: hidden;
		position: relative;

		.owl-carousel {
			.item {
        // height: 400px;
				display: flex;
				align-items: center;
				background-size: cover;
				background-position: center;
				a{
					display: block;
					width: 100%;
				}
				.img{
					width: 100%;
				}
			}

			.owl-nav{
				font-size: 0;
				div{
					width: 42px;
					height: 42px;
					border-radius: 100%;
					background-color: rgba(white, .7);
					@include single-transition();
					background-size: 25px;
					background-position: center;
					background-repeat: no-repeat;
					background-image: url('../img/arr.svg');
					z-index: 3;
					&:hover{
						background-color: white;
					}
				}
				.owl-prev{
					position: absolute;
					// bottom: 30px;
					left: 10px;
					transform: rotate(90deg);
          			top: calc(50% - 21px);
					@include m_up{
						left: 25px;
					};
					@media (min-width: 1281px){
						left: 30px;
					}
				}
				.owl-next{
					position: absolute;
					// bottom: 30px;
					right: 10px;
					transform: rotate(-90deg);
          			top: calc(50% - 21px);
					@include m_up{
						right: 25px;
					};
					@media (min-width: 1281px){
						right: 30px;
					}
					// @include l___up{
					// 	right: calc(50% - 790px);
					// };
				}
			}
			.owl-dots {
				position: absolute;
				bottom: 10px;
				width: 100%;
				text-align: center;
				z-index: 2;
				@include l_up{
					bottom: 20px;
				};
				.owl-dot {
					display: inline-block;
					width: 12px;
					height: 12px;
					border-radius: 100%;
					cursor: pointer;
					margin: 0 5px;
					border: 1px solid black;
					@include single-transition(all, 300ms, ease);
					position: relative;
					&:before{
						position: absolute;
						width: 6px;
						height: 6px;
						content: "";
						border-radius: 100%;
						left: calc(50% - 3px);
						top: calc(50% - 3px);
						opacity: 0;
					}
					&:hover, &.active {
						border-color: var(--bg-color);
						&:before{
							opacity: 1;
							background-color: var(--bg-color);
						}
						// background-color: #fff;
						@include single-transition(all, 300ms, ease);
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// main-slider-v2.vue?1fe8af46